/* eslint-disable */
import create from "@/apollo/cruises/masters/ports/create.gql";
import listing from "@/apollo/cruises/masters/ports/listing.gql";
import port_by_id from "@/apollo/cruises/masters/ports/by_id.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 12:27PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 12:27PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 12:27PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 12:27PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.cruise_fetch_ports);
          resolve(data.cruise_fetch_ports);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 14 Jan 2025 | 12:27PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  create({ commit }, payload) {
    commit("setCreating", true);
    return new Promise(async (resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: create, variables: { payload } })
        .then(({ data }) => {
          resolve(data.cruise_create_port);
          commit("setCreating", false);
        })
        .catch((err) => {
          reject(err);
          commit("setCreating", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 23 Jan 2025 | 10:47AM
   * @param {*} __
   * @param {*} _id
   * @returns {*}
   */
  by_id(__, _id) {
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .query({ query: port_by_id, variables: { _id } })
        .then(({ data }) => resolve(data.cruise_fetch_port_id))
        .catch((err) => reject(err));
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
